import React from "react";
import {
  DialogContent,
  Dialog,
  Grid,
  DialogActions,
  TableContainer,
  Toolbar,
  Typography,
  Tooltip,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
} from "@material-ui/core";
import AppBarModal from "../../general/AppBarModal";
import {
  BtnDetalle,
  BtnEditar,
  BtnEliminar,
  BtnForm,
} from "../../general/BotonesAccion";
import AddIcon from "@material-ui/icons/Add";
import { withStyles } from "@material-ui/core/styles";
import TareasTerminadas from "../../general/TareasTerminadas";
import ExportarRubricasExcel from "./ExportarRubricasExcel";

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#B70E0C",
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

export default function TablasRubricas(props) {
  const Modificar = (fila) => {
    let criterio = {},
      avanzado = {},
      excelente = {},
      minimo = {},
      insuficiente = {},
      satisfactorio = {},
      id = { corte: fila.corte, id: fila.id };
    criterio.valor = fila.criterio;
    props.criterio(criterio);
    avanzado.valor = fila.avanzado;
    props.avanzado(avanzado);
    excelente.valor = fila.excelente;
    props.excelente(excelente);
    minimo.valor = fila.minimo;
    props.minimo(minimo);
    insuficiente.valor = fila.insuficiente;
    props.insuficiente(insuficiente);
    satisfactorio.valor = fila.satisfactorio;
    props.satisfactorio(satisfactorio);
    props.id_actual(id);
    props.EditarModal(true);
  };

  const Eliminar = (fila) => {
    let id = {};
    id.corte = fila.corte;
    id.id = fila.id;
    props.id_actual(id);
    props.Eliminar(true);
  };

  const Detalle = (fila) => {
    props.DetalleObjetivo(fila.id);
  };

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={props.modal}
        onClose={() => props.cerrarModal(false)}
      >
        <AppBarModal
          titulo={props.Titulo}
          titulo_accion="U. Formación"
          mostrarModal={() => props.cerrarModal(false)}
        />
        <DialogContent className="scroll">
          <Grid container spacing={3}>
            <Paper style={{ width: "100%", margin: "10px", padding: "10px" }}>
              <TableContainer>
                <Table stickyHeader aria-label="sticky table" style={{ width: "100%", marginTop: "3px" }}>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell align="left">Criterios de evaluación</StyledTableCell>
                      <StyledTableCell align="left">Excelente</StyledTableCell>
                      <StyledTableCell align="left">Avanzado</StyledTableCell>
                      <StyledTableCell align="left">Satisfactorio</StyledTableCell>
                      <StyledTableCell align="left">Mínimo</StyledTableCell>
                      <StyledTableCell align="left">Insuficiente</StyledTableCell>
                      <StyledTableCell align="left"></StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {props.data_rubrica.length === 0 ? (
                      <TableRow>
                        <TableCell align="center" colSpan={7}>
                          <div className="contenido_modulo">
                            <TareasTerminadas
                              mensaje="Por el momento no ha sido agregada ninguna nota, agregar las notas correspondientes."
                              marginTop="7%"
                              imagen={props.imagen}
                              widthImg="7%"
                            />
                          </div>
                        </TableCell>
                      </TableRow>
                    ) : (
                      props.data_rubrica.map((column) => (
                        <TableRow key={column.id}>
                          <TableCell align="left">{column.criterio}</TableCell>
                          <TableCell align="left">{column.excelente}</TableCell>
                          <TableCell align="left">{column.avanzado}</TableCell>
                          <TableCell align="left">{column.satisfactorio}</TableCell>
                          <TableCell align="left">{column.minimo}</TableCell>
                          <TableCell align="left">{column.insuficiente}</TableCell>
                          <TableCell align="left">
                            <BtnDetalle callback={() => Detalle(column)} />
                          {
                              props.administrador &&
                              <>
                              <BtnEditar callback={() => Modificar(column)} />
                              <BtnEliminar callback={() => Eliminar(column)} />
                              </>
                            }
                            </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Grid>
        </DialogContent>
        <DialogActions>

          {/* <Tooltip title="Nuevo" > */}
          {/* <IconButton
                      aria-label="Nuevo"
                      backgroundColor="#c79c3e"
                      color="primary"
                      onClick={() => {
                        props.modalAgregar(true);
                        this.resetmodalAgregar();
                      }}
                    >
                      <AddIcon />
                    </IconButton> */}
          {/* <IconButton
                    aria-label="Nuevo"
                    backgroundColor="#c79c3e"
                    color="primary"
                    onClick={() => {
                      props.modalAgregar(true);
                    }}
                  >
                  <AddIcon />
                </IconButton>

                </Tooltip>  */}
          {
            props.administrador &&
              <BtnForm texto="Nuevo" callback={() => props.modalAgregar(true)} />
          }
          <BtnForm texto="CANCELAR" callback={() => props.cerrarModal(false)} />
          <ExportarRubricasExcel data={props.data_rubrica} nombre={`Rubrica`} />
        </DialogActions>

      </Dialog>
    </div>
  );
}
